import { cn } from '@repo/tailwind-config/tailwind.functions'
import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import React, { PropsWithChildren } from 'react'

import Typography, { TypographyProps } from './typography'

type InnerBoxProps = {
  id?: string
  title?: string
  hasTitleSpace?: boolean
  subTitle?: string
  className?: string
  titleColor?: TailwindColor
  header?: string | React.ReactNode
  headerClassName?: string
}

export const InnerBoxTitle: React.FC<{
  title: string
  subTitle?: string
  titleColor?: TailwindColor
  titleVariant?: TypographyProps['variant']
}> = ({ title, subTitle, titleColor, titleVariant = 'body-medium' }) => {
  return (
    <div className="flex gap-2 items-center">
      <Typography variant={titleVariant} color={titleColor ?? tailwindColors.primary.DEFAULT}>
        {title}
      </Typography>
      <Typography variant="label-semibold" color={tailwindColors.blue.DEFAULT}>
        {subTitle}
      </Typography>
    </div>
  )
}

const InnerBox: React.FC<PropsWithChildren<InnerBoxProps>> = ({
  id,
  title,
  subTitle,
  hasTitleSpace = true,
  children,
  titleColor,
  className,
  headerClassName,
  header
}) => {
  return (
    <div
      id={id}
      className={cn(
        'p-4 border border-grey-light rounded flex flex-col',
        { 'p-0 border-primary-light rounded-lg': !!header },
        className
      )}
    >
      {header && (
        <>
          <div className={cn('bg-primary-light rounded-lg p-4', headerClassName)}>
            {typeof header === 'string' ? (
              <Typography variant="text" color={tailwindColors.black.DEFAULT}>
                {header}
              </Typography>
            ) : (
              header
            )}
          </div>
        </>
      )}
      {title && (
        <>
          <InnerBoxTitle title={title} subTitle={subTitle} titleColor={titleColor} />
          {hasTitleSpace && <div className="h-4 mobile:h-2" />}
        </>
      )}

      {children}
      {header && <div className="h-4" />}
    </div>
  )
}

export default InnerBox
